export default "__VITE_ASSET__C3d4IKcl__"